import React from 'react';

export default function Liveries() {
  return (
    <div style={{ paddingTop: '4rem' }}>
      <h1 className="title" style={{ marginTop: 0, textAlign: 'center' }}>Liveries</h1>
      <p className="subtitle" style={{ textAlign: 'center' }}>
        This is where I’ll showcase flight simulator liveries I design for various aircraft.
        Check back for downloads, previews, and paint kit notes.
      </p>
    </div>
  );
}
